<template>
  <v-dialog
    v-model="model"
    max-width="520"
    transition="dialog-bottom-transition"
    :persistent="busy"
    @keydown.esc="onEsc"
  >
    <v-card class="rac2">
      <div class="rac2-caption">{{ header }}</div>

      <div class="rac2-icon">
        <v-icon large color="#ff9800">mdi-information</v-icon>
      </div>


      <div class="rac2-body">

        <template v-if="kind==='confirm'">
          <p class="rac2-lead">
            Резерв перейдёт в статус <b>Согласование</b>
          </p>

          <template v-if="trunks.length">
            <div class="rac2-sub">Для пользователя будет зарезервировано:</div>
            <ul class="rac2-list">
              <li v-for="(t,i) in trunks" :key="i">
                <code>{{ t.queueTrunk }}</code>: {{ t.count }} номеров
              </li>
            </ul>
          </template>

          <div v-if="totalMoney>0" class="rac2-money">
            Со счёта будет списано: <b>{{ fmtRub(totalMoney) }}</b>
          </div>
        </template>


        <template v-else-if="kind==='delete_review'">
          <p class="rac2-lead">Резерв будет <b>удалён</b></p>
          <div v-if="trunks.length" class="rac2-sub">
            Бронирование будет отменено.
          </div>
          <div v-if="totalMoney>0" class="rac2-money">
            Вернётся пользователю на баланс: <b>{{ fmtRub(totalMoney) }}</b>
          </div>
        </template>

        <template v-else-if="kind==='delete_other'">
          <p class="rac2-lead">Резерв будет <b>удалён</b></p>

          <div class="rac2-sub" v-if="isActive">
            Все номера будут перемещены в пул <code>util</code>.
          </div>
          <div class="rac2-sub" v-else>
            В <code>reserve_pool</code> транков вернутся:
          </div>

          <ul class="rac2-list" v-if="trunks.length">
            <li v-for="(t,i) in trunks" :key="i">
              <code>{{ t.queueTrunk }}</code>: {{ t.count }} номеров
            </li>
          </ul>


          <div class="rac2-money" v-if="!isActive && totalMoney>0">
            Вернётся пользователю на баланс: <b>{{ fmtRub(totalMoney) }}</b>
          </div>
          <div class="rac2-money" v-else-if="isActive">
            Средства <b>не возвращаются</b>.
          </div>
        </template>


        <template v-else-if="kind==='activate'">
          <p class="rac2-lead">
            Резерв перейдёт в статус <b>Активен</b>
          </p>
          <div class="rac2-sub">
            Резерв станет доступен для формирования каруселей и звонков.
          </div>
        </template>

        <div v-if="apiError" class="rac2-error">{{ apiError }}</div>
      </div>

      <div class="rac2-actions">
        <v-btn
          block
          color="primary"
          class="white--text"
          :loading="busy"
          :disabled="busy"
          @click="confirm"
        >
          Подтвердить
        </v-btn>
        <button class="rac2-cancel" :disabled="busy" @click="cancel">
          Отменить
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReserveActionConfirm',
  props: {
    value: { type: Boolean, required: true },
    kind:  { type: String,  required: true },
    row:   { type: Object,  default: () => ({}) }
  },
  emits: ['input','ok','cancel'],
  data(){ return { busy:false, apiError:'' } },

  computed:{
    model:{ get(){ return this.value }, set(v){ this.$emit('input', v) } },

    normStatus(){
      let s = String(
        this.row?.status ??
        this.row?.status_code ??
        this.row?.statusCode ??
        ''
      ).trim().toLowerCase();

      if (this.row?.isActive === true || this.row?.active === true) s = 'active';

      if (['active','активен','активная','активный'].includes(s)) return 'active';
      if (['pending','согласование','на согласование','согласован','согласована'].includes(s)) return 'pending';
      if (['review','на проверке','проверка'].includes(s)) return 'review';
      return s || 'review';
    },
    isActive(){ return this.normStatus === 'active' },

    header(){
      if (this.kind === 'delete_other') {
        return this.isActive
          ? 'Статус «Активен». Удалить резерв — подтверждение операции'
          : 'Статус «Согласование». Удалить резерв — подтверждение операции';
      }
      const map = {
        confirm:       'Статус «На проверке». На согласование — подтверждение операции',
        delete_review: 'Статус «На проверке». Удалить заявку — подтверждение операции',
        activate:      'Статус «Согласование». Активировать — подтверждение операции'
      };
      return map[this.kind] || 'Подтверждение операции';
    },

    trunks(){
      const arr = Array.isArray(this.row?.trunks) ? this.row.trunks : [];
      return arr
        .map(t => ({
          queueTrunk: String(t.queueTrunk || t.carouselId || t.carousel || ''),
          count: Number(t.count || t.numbers || 0) || 0
        }))
        .filter(t => t.queueTrunk && t.count > 0);
    },

    totalMoney(){
      const direct = Number(this.row?.rentCostRaw ?? this.row?.total ?? 0);
      if (Number.isFinite(direct) && direct > 0) return direct;

      const price = Number(this.row?.price || 0) || 0;
      const qtyFromTrunks = this.trunks.reduce((s,t)=>s + (t.count || 0), 0);
      const qty = qtyFromTrunks || Number(this.row?.numbersCount || 0) || 0;
      return Math.max(0, Math.round(price * qty));
    }
  },

  methods:{
    fmtRub(v){
      try { return new Intl.NumberFormat('ru-RU').format(Number(v)||0) + ' ₽' }
      catch { return (Number(v)||0) + ' ₽' }
    },
    onEsc(){ if (!this.busy) this.model = false },
    cancel(){
      if (this.busy) return
      this.model = false
      this.$emit('cancel')
    },
    async confirm(){
      if (this.busy) return
      this.busy = true; this.apiError = ''
      try{
        await this.$emit('ok')
        this.model = false
      }catch(e){
        this.apiError = 'Не удалось выполнить операцию'
      }finally{
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.rac2{ padding:16px 18px 14px; border-radius:10px; }
.rac2-caption{
  font:600 12px/1.25 Manrope, sans-serif;
  color:#9CA3AF;
  text-align:left;
  margin-bottom:8px;
}
.rac2-icon{
  width:44px; height:44px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  background:#FFF4E5;
  margin:0 auto 8px;
}
.rac2-body{ text-align:center; color:#2B2D33; }
.rac2-lead{ margin:8px 0 6px; font:600 16px/1.35 Manrope, sans-serif; }
.rac2-sub{ margin-top:2px; font:500 13px/1.4 Manrope, sans-serif; color:#6F7075; }
.rac2-list{ list-style:none; padding-left:0; margin:8px 0 0; text-align:left; }
.rac2-list li{ font:500 14px/1.4 Manrope, sans-serif; margin:2px 0; }
.rac2-money{ margin-top:10px; font:600 14px/1.35 Manrope, sans-serif; }
.rac2-error{ margin-top:10px; color:#EE505A; font:500 13px/1.3 Manrope, sans-serif; }

.rac2-actions{ margin-top:16px; }
.rac2-cancel{
  display:block; width:100%;
  margin-top:8px; border:0; background:transparent; padding:8px 0;
  font:600 14px/1.2 Manrope, sans-serif; color:#6F7075; cursor:pointer;
}
.rac2-cancel[disabled]{ opacity:.6; cursor:default; }
</style>
